import { ProfileTypes } from '@/finsight/application/actions/profile/constants';
import { toSlug } from '@/Framework/url/helpers/toSlug';
import URL from '@/finsight/Router/urlConstants';
import { getMarketOverviewBreadcrumbsRoute } from '@/finsight/ui/common/helpers';

export const getProfileBreadcrumbs = (sectorOrIndustryData, filters) => {
  if (sectorOrIndustryData.profileType === ProfileTypes.OVERVIEW) {
    return [{
      title: 'Market Overview',
      isActive: true,
    }];
  }
  let breadcrumbsTale = [];
  if (sectorOrIndustryData.subitemName) {
    breadcrumbsTale = [
      {
        title: sectorOrIndustryData.itemName,
        url: `/${ toSlug(sectorOrIndustryData.itemName) }-${
          sectorOrIndustryData.profileType === ProfileTypes.SECTOR ? URL.SECTOR_SUFFIX : URL.INDUSTRY_SUFFIX
        }?products=${
          encodeURI(filters.products)
        }&regions=${
          encodeURI(filters.regions)
        }`,
      },
      {
        title: sectorOrIndustryData.subitemName,
        isActive: true,
      },
    ];
  } else {
    breadcrumbsTale = [
      {
        title: sectorOrIndustryData.itemName,
        isActive: true,
      },
    ];
  }
  return [
    getMarketOverviewBreadcrumbsRoute(filters),
    ...breadcrumbsTale,
  ];
};

export default getProfileBreadcrumbs;
